import SucessoFestivoIcon from "shared/components/icons/SucessoFestivoIcon";
import "./TelaAtivacaoConcluidaGroupSign.css";

const TelaAtivacaoConcluidaGroupSign: React.FC = () => {
  const renderBodyTelaAtivacaoGroupSign = () => {
    return <div className="body-tela-ativacao-concluida-sign">{renderTextoConclusao()}</div>;
  };

  const renderTextoConclusao = () => {
    return (
      <div>
        <SucessoFestivoIcon />
        <div className="font-weight-600 font-size-30">
          A sua ativação da <span style={{ color: "#216c7b" }}>Assinatura digital</span><br />  foi iniciada!
        </div>
        <div  className="font-size-15">
          Em  até 24h um dos nossos consultores entrará em contato com você para seguir <br /> 
           com o próximo passo e dar inicio a uma nova fase na sua gestão.
        </div>
      </div>
    );
  };

  return <>{renderBodyTelaAtivacaoGroupSign()}</>;
};

export default TelaAtivacaoConcluidaGroupSign;
